module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append(escapeFn( locals.count ))
    ; __append("<small class=\"text-muted text-blue\"> (")
    ; __append(escapeFn( locals.percent ))
    ; __append("%)</small> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/tracking_status_report/count_and_percent_heading.ejs
// module id = 851
// module chunks = 1